// extracted by mini-css-extract-plugin
export var caption = "DoDontRow-module--caption--f2d3f";
export var card = "DoDontRow-module--card--82ccb";
export var cardContent = "DoDontRow-module--card-content--cdc39";
export var cdsAssistiveText = "DoDontRow-module--cds--assistive-text--bc2e2";
export var cdsVisuallyHidden = "DoDontRow-module--cds--visually-hidden--5ddf5";
export var content = "DoDontRow-module--content--d7d86";
export var correct = "DoDontRow-module--correct--f6eea";
export var dark = "DoDontRow-module--dark--47e64";
export var description = "DoDontRow-module--description--7b6e4";
export var doDontRow = "DoDontRow-module--do-dont-row--9ae8d";
export var example = "DoDontRow-module--example--e6b82";
export var hideFeedback = "DoDontRow-module--hide-feedback--9d664";
export var icon = "DoDontRow-module--icon--72999";
export var iconCorrect = "DoDontRow-module--icon-correct--1c9fa";
export var iconIncorrect = "DoDontRow-module--icon-incorrect--f1c76";
export var image = "DoDontRow-module--image--f8551";
export var incorrect = "DoDontRow-module--incorrect--1cf82";
export var ratio = "DoDontRow-module--ratio--06efd";
export var ratio16x9 = "DoDontRow-module--ratio16x9--9cbbe";
export var ratio1x1 = "DoDontRow-module--ratio1x1--19dc4";
export var ratio1x2 = "DoDontRow-module--ratio1x2--2395c";
export var ratio2x1 = "DoDontRow-module--ratio2x1--70227";
export var ratio3x4 = "DoDontRow-module--ratio3x4--9262d";
export var ratio4x3 = "DoDontRow-module--ratio4x3--9a6ab";
export var ratio9x16 = "DoDontRow-module--ratio9x16--d32c5";
export var showFeedback = "DoDontRow-module--show-feedback--b5fc0";
export var skeleton = "DoDontRow-module--skeleton--1c961";
export var text = "DoDontRow-module--text--9b356";
export var title = "DoDontRow-module--title--8232a";